import React from 'react'

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  return (
    <div style={{width: '100%'}}>
      <footer className="main-footer">
        <div className="footer-container">
          <div className="inner">
            <div>
              <strong> STUDYBOT </strong>
              <a href="https://codepen.io/bigglesrocks/pen/LoBsD"> Credit </a>
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSfac5hZbc8rHVOnPuVqBKErExi-ETCIMsxsMdb1o4s_re5slQ/viewform"> Give Feedback </a>
              <a href = "https://logomakr.com/"> Logo Makr </a>
            </div>
            <div className = "company">
              <strong> Our Company </strong>
              <a href="#"> Instagram </a>
              <a href="mailto: kangjohn00000@gmail.com"> Facebook </a>
              <a href="#"> New Look </a>
            </div>
            <div className = "help">
              <strong> Help </strong>
              <a href="#"> Find an answer </a>
              <a href="#"> Help Centre </a>
            </div>
          </div>
          <div className="footer-2">
            <strong> Contact </strong>
            <a href="mailto: kangjohn00000@gmail.com"> kangjohn00000@gmail.com </a>
          </div>
        </div>


      </footer>

      <footer className="footer2">

        <a href="#"> &#169; STUDYBOT </a>
        <a href="#">Terms and Conditions</a>
        <a href="#">Privacy </a>

      </footer>
    </div>
  )
}
